import { EventHandler, RefObject, SyntheticEvent, useEffect } from 'react';

export const useOutsideEventHandler = (
  ref: RefObject<HTMLElement>,
  handler: EventHandler<SyntheticEvent>,
  eventType: string = 'click',
  deps: Array<any> = [],
) => {
  const conditionalHandler = (e) => {
    if (window.__activeConfirm || !ref.current) {
      return;
    }

    if (ref.current && !ref.current.contains(e.target) && ref.current !== e.target) {
      handler(e);
    }
  };

  useEffect(() => {
    document.addEventListener(eventType, conditionalHandler);
    return () => document.removeEventListener(eventType, conditionalHandler);
  }, deps);
};
